import { Button } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardMembershipRoundedIcon from '@material-ui/icons/CardMembershipRounded';
import EmojiFoodBeverageRoundedIcon from '@material-ui/icons/EmojiFoodBeverageRounded';
import ImportContactsRoundedIcon from '@material-ui/icons/ImportContactsRounded';
import RepeatRoundedIcon from '@material-ui/icons/RepeatRounded';
import AssistantRoundedIcon from '@material-ui/icons/AssistantRounded';
import StyleRoundedIcon from '@material-ui/icons/StyleRounded';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.6rem',
    fontWeight: '600',
    margin: '12px 0',
  },
  buttons: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridColumnGap: '0',
    gridRowGap: '12px',
  },
  button: {
    fontSize: '1.1rem',
    fontWeight: '600',
    height: '90px',
    width: '90%',
    margin: 'auto',
  },
}));

const SelectMode = (props) => {
  const { selectMode } = props;
  const classes = useStyles();

  const handleSelectMode = (mode) => {
    selectMode(mode);
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>服務</div>
      <div className={classes.buttons}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => handleSelectMode('bonus')}
          endIcon={<CardMembershipRoundedIcon />}>
          點數 | 扺用券
        </Button>

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => handleSelectMode('paper')}
          endIcon={<StyleRoundedIcon />}>
          紙本券
        </Button>

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => handleSelectMode('guestCard')}
          endIcon={<ImportContactsRoundedIcon />}>
          共享空間
        </Button>

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => handleSelectMode('dailyClaim')}
          endIcon={<EmojiFoodBeverageRoundedIcon />}>
          每日領取
        </Button>
      </div>

      <div className={classes.title}>購買</div>
      <div className={classes.buttons}>
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={() => handleSelectMode('payingMember')}
          endIcon={<AssistantRoundedIcon />}>
          VIP會員
        </Button>

        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={() => handleSelectMode('subscription')}
          endIcon={<RepeatRoundedIcon />}>
          訂閱服務
        </Button>
      </div>
    </div>
  );
};

export default SelectMode;
